import { connect } from 'react-redux';
import Header from './Header';
import { showLoginModal } from '../../redux/modules/login';

const mapDispatchToProps = {
  showLoginModal
};

const mapStateToProps = ({
  system: { siteName, isTouchDevice },
  intl: { locale, currency },
  user: { isUserLogged },
  content: { header: data }
}) => ({
  siteName,
  locale,
  isTouchDevice,
  isUserLogged,
  data,
  currency
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
